import { getItem, setItem } from './localStorageControl';

const APPLICATIONS_KEY = 'sang_vendor_applications';
const ACTIVITIES_KEY = 'sang_vendor_activities';

const getFutureIsoTime = (minutesFromNow) => new Date(Date.now() + minutesFromNow * 60 * 1000).toISOString();

const initialApplications = [
  {
    id: 'APP-1001',
    deviceModel: 'Apple iPhone 13 Pro - 256GB',
    customerName: 'Rahul Kumar',
    date: '2026-05-22',
    condition: 'Used - Heavily Worn',
    initialQuote: 35000,
    quotedAmount: 38000,
    status: 'Accepted', // Accepted | Rejected | Quoted | Pending | Declined
    images: [
      'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?q=80&w=400&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1592899677974-c46409511b4d?q=80&w=400&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1601784551446-20c9e07cd561?q=80&w=400&auto=format&fit=crop'
    ],
    checkDetails: [
      { id: 1, question: 'Is the front screen glass cracked?', answer: 'Yes' },
      { id: 2, question: 'Does the display show lines, black spots, ink bleed, or dead areas?', answer: 'No' },
      { id: 3, question: 'Is any external part missing (buttons, SIM tray, camera lens cover, etc.)?', answer: 'No' },
      { id: 4, question: 'Is the camera lens cracked?', answer: 'No' },
      { id: 5, question: 'Is the back glass cracked or shattered?', answer: 'Yes' },
      { id: 6, question: 'Is the phone frame bent, warped, or showing visible gaps?', answer: 'No' },
      { id: 7, question: 'Are there deep scratches visible from arm\'s length?', answer: 'Yes' },
      { id: 8, question: 'Does the phone have heavy cosmetic wear (large dents, severe scuffs, discoloration)?', answer: 'Yes' },
      { id: 9, question: 'Does the phone appear well-maintained overall? (Yes = good condition)', answer: 'No' },
      { id: 10, question: 'Are the original box and accessories available? (Optional – affects value)', answer: 'No' },
    ]
  },
  {
    id: 'APP-0995',
    deviceModel: 'Samsung Galaxy S22 Ultra - 256GB',
    customerName: 'Aman Verma',
    date: '2026-05-18',
    condition: 'Good',
    initialQuote: 40000,
    quotedAmount: 42000,
    status: 'Rejected',
    images: [
      'https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?q=80&w=400&auto=format&fit=crop'
    ],
    checkDetails: [
      { id: 1, question: 'Is the front screen glass cracked?', answer: 'No' },
      { id: 2, question: 'Does the display show lines, black spots, ink bleed, or dead areas?', answer: 'No' },
      { id: 3, question: 'Is any external part missing (buttons, SIM tray, camera lens cover, etc.)?', answer: 'No' },
      { id: 4, question: 'Is the camera lens cracked?', answer: 'No' },
      { id: 5, question: 'Is the back glass cracked or shattered?', answer: 'No' },
      { id: 6, question: 'Is the phone frame bent, warped, or showing visible gaps?', answer: 'No' },
      { id: 7, question: 'Are there deep scratches visible from arm\'s length?', answer: 'No' },
      { id: 8, question: 'Does the phone have heavy cosmetic wear (large dents, severe scuffs, discoloration)?', answer: 'No' },
      { id: 9, question: 'Does the phone appear well-maintained overall? (Yes = good condition)', answer: 'Yes' },
      { id: 10, question: 'Are the original box and accessories available? (Optional – affects value)', answer: 'Yes' },
    ]
  },
  {
    id: 'APP-0992',
    deviceModel: 'OnePlus 10 Pro - 128GB',
    customerName: 'Sanjay Dutt',
    date: '2026-05-15',
    condition: 'Damaged',
    initialQuote: 20000,
    quotedAmount: 22000,
    status: 'Accepted',
    images: [
      'https://images.unsplash.com/photo-1598327105666-5b89351aff97?q=80&w=400&auto=format&fit=crop'
    ],
    checkDetails: [
      { id: 1, question: 'Is the front screen glass cracked?', answer: 'Yes' },
      { id: 2, question: 'Does the display show lines, black spots, ink bleed, or dead areas?', answer: 'Yes' },
      { id: 3, question: 'Is any external part missing (buttons, SIM tray, camera lens cover, etc.)?', answer: 'No' },
      { id: 4, question: 'Is the camera lens cracked?', answer: 'No' },
      { id: 5, question: 'Is the back glass cracked or shattered?', answer: 'No' },
      { id: 6, question: 'Is the phone frame bent, warped, or showing visible gaps?', answer: 'Yes' },
      { id: 7, question: 'Are there deep scratches visible from arm\'s length?', answer: 'Yes' },
      { id: 8, question: 'Does the phone have heavy cosmetic wear (large dents, severe scuffs, discoloration)?', answer: 'Yes' },
      { id: 9, question: 'Does the phone appear well-maintained overall? (Yes = good condition)', answer: 'No' },
      { id: 10, question: 'Are the original box and accessories available? (Optional – affects value)', answer: 'No' },
    ]
  },
  {
    id: 'APP-0988',
    deviceModel: 'Google Pixel 7a - 128GB',
    customerName: 'Meera Nair',
    date: '2026-05-12',
    condition: 'New',
    initialQuote: 27000,
    quotedAmount: 29000,
    status: 'Quoted', // Quoted (Pending Review)
    images: [
      'https://images.unsplash.com/photo-1598327105666-5b89351aff97?q=80&w=400&auto=format&fit=crop'
    ],
    checkDetails: [
      { id: 1, question: 'Is the front screen glass cracked?', answer: 'No' },
      { id: 2, question: 'Does the display show lines, black spots, ink bleed, or dead areas?', answer: 'No' },
      { id: 3, question: 'Is any external part missing (buttons, SIM tray, camera lens cover, etc.)?', answer: 'No' },
      { id: 4, question: 'Is the camera lens cracked?', answer: 'No' },
      { id: 5, question: 'Is the back glass cracked or shattered?', answer: 'No' },
      { id: 6, question: 'Is the phone frame bent, warped, or showing visible gaps?', answer: 'No' },
      { id: 7, question: 'Are there deep scratches visible from arm\'s length?', answer: 'No' },
      { id: 8, question: 'Does the phone have heavy cosmetic wear (large dents, severe scuffs, discoloration)?', answer: 'No' },
      { id: 9, question: 'Does the phone appear well-maintained overall? (Yes = good condition)', answer: 'Yes' },
      { id: 10, question: 'Are the original box and accessories available? (Optional – affects value)', answer: 'Yes' },
    ]
  },
  {
    id: 'APP-1002',
    deviceModel: 'Samsung Galaxy S23 Ultra - 512GB',
    customerName: 'Priya Sharma',
    date: '2026-05-22',
    condition: 'Good',
    initialQuote: 52000,
    images: [
      'https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?q=80&w=400&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1585060544812-6b45742d762f?q=80&w=400&auto=format&fit=crop',
    ],
    checkDetails: [
      { id: 1, question: 'Is the front screen glass cracked?', answer: 'No' },
      { id: 2, question: 'Does the display show lines, black spots, ink bleed, or dead areas?', answer: 'No' },
      { id: 3, question: 'Is any external part missing (buttons, SIM tray, camera lens cover, etc.)?', answer: 'No' },
      { id: 4, question: 'Is the camera lens cracked?', answer: 'No' },
      { id: 5, question: 'Is the back glass cracked or shattered?', answer: 'No' },
      { id: 6, question: 'Is the phone frame bent, warped, or showing visible gaps?', answer: 'No' },
      { id: 7, question: 'Are there deep scratches visible from arm\'s length?', answer: 'No' },
      { id: 8, question: 'Does the phone have heavy cosmetic wear (large dents, severe scuffs, discoloration)?', answer: 'No' },
      { id: 9, question: 'Does the phone appear well-maintained overall? (Yes = good condition)', answer: 'Yes' },
      { id: 10, question: 'Are the original box and accessories available? (Optional – affects value)', answer: 'Yes' },
    ],
    status: 'Pending',
    endTime: getFutureIsoTime(45)
  },
  {
    id: 'APP-1003',
    deviceModel: 'OnePlus 11 5G - 256GB',
    customerName: 'Vikram Singh',
    date: '2026-05-21',
    condition: 'Damaged',
    initialQuote: 31000,
    images: [
      'https://images.unsplash.com/photo-1598327105666-5b89351aff97?q=80&w=400&auto=format&fit=crop',
      'https://images.unsplash.com/photo-1565630916779-e303be97b6f5?q=80&w=400&auto=format&fit=crop'
    ],
    checkDetails: [
      { id: 1, question: 'Is the front screen glass cracked?', answer: 'Yes' },
      { id: 2, question: 'Does the display show lines, black spots, ink bleed, or dead areas?', answer: 'Yes' },
      { id: 3, question: 'Is any external part missing (buttons, SIM tray, camera lens cover, etc.)?', answer: 'Yes' },
      { id: 4, question: 'Is the camera lens cracked?', answer: 'No' },
      { id: 5, question: 'Is the back glass cracked or shattered?', answer: 'No' },
      { id: 6, question: 'Is the phone frame bent, warped, or showing visible gaps?', answer: 'Yes' },
      { id: 7, question: 'Are there deep scratches visible from arm\'s length?', answer: 'Yes' },
      { id: 8, question: 'Does the phone have heavy cosmetic wear (large dents, severe scuffs, discoloration)?', answer: 'Yes' },
      { id: 9, question: 'Does the phone appear well-maintained overall? (Yes = good condition)', answer: 'No' },
      { id: 10, question: 'Are the original box and accessories available? (Optional – affects value)', answer: 'No' },
    ],
    status: 'Pending',
    endTime: getFutureIsoTime(25)
  },
  {
    id: 'APP-1004',
    deviceModel: 'Google Pixel 8 Pro - 128GB',
    customerName: 'Ananya Sen',
    date: '2026-05-20',
    condition: 'New',
    initialQuote: 45000,
    images: [
      'https://images.unsplash.com/photo-1598327105666-5b89351aff97?q=80&w=400&auto=format&fit=crop'
    ],
    checkDetails: [
      { id: 1, question: 'Is the front screen glass cracked?', answer: 'No' },
      { id: 2, question: 'Does the display show lines, black spots, ink bleed, or dead areas?', answer: 'No' },
      { id: 3, question: 'Is any external part missing (buttons, SIM tray, camera lens cover, etc.)?', answer: 'No' },
      { id: 4, question: 'Is the camera lens cracked?', answer: 'No' },
      { id: 5, question: 'Is the back glass cracked or shattered?', answer: 'No' },
      { id: 6, question: 'Is the phone frame bent, warped, or showing visible gaps?', answer: 'No' },
      { id: 7, question: 'Are there deep scratches visible from arm\'s length?', answer: 'No' },
      { id: 8, question: 'Does the phone have heavy cosmetic wear (large dents, severe scuffs, discoloration)?', answer: 'No' },
      { id: 9, question: 'Does the phone appear well-maintained overall? (Yes = good condition)', answer: 'Yes' },
      { id: 10, question: 'Are the original box and accessories available? (Optional – affects value)', answer: 'Yes' },
    ],
    status: 'Pending',
    endTime: getFutureIsoTime(65)
  }
];

const initialActivities = [
  { id: 1, text: 'Quote approved for ₹38,000 on Apple iPhone 13 Pro (APP-1001)', time: '10 minutes ago', type: 'success' },
  { id: 2, text: 'Quote rejected for ₹42,000 on Samsung Galaxy S22 Ultra (APP-0995)', time: '2 hours ago', type: 'error' },
  { id: 3, text: 'Submitted quote of ₹29,000 for Google Pixel 7a (APP-0988)', time: '4 hours ago', type: 'info' },
  { id: 4, text: 'New inspection report uploaded for Samsung Galaxy S23 Ultra (APP-1002)', time: '1 day ago', type: 'warning' },
  { id: 5, text: 'Quote approved for ₹22,000 on OnePlus 10 Pro (APP-0992)', time: '2 days ago', type: 'success' },
];

export const mockStore = {
  getApplications() {
    let apps = getItem(APPLICATIONS_KEY);
    if (!apps || !Array.isArray(apps) || apps.length === 0) {
      setItem(APPLICATIONS_KEY, initialApplications);
      return initialApplications;
    }
    // Self-healing check: ensure all applications use the current quote fields.
    let updated = false;
    const fallbackInitialQuotes = {
      'APP-1001': 35000,
      'APP-0995': 40000,
      'APP-0992': 20000,
      'APP-0988': 27000,
      'APP-1002': 52000,
      'APP-1003': 31000,
      'APP-1004': 45000
    };
    apps = apps.map(app => {
      if (app.quotedAmount === undefined && app.finalQuote !== undefined) {
        app.quotedAmount = app.finalQuote;
        delete app.finalQuote;
        updated = true;
      }
      if (app.initialQuote === undefined) {
        app.initialQuote = fallbackInitialQuotes[app.id] || app.quotedAmount || 0;
        updated = true;
      }
      if (app.finalQuote !== undefined) {
        delete app.finalQuote;
        updated = true;
      }
      if (app.status === 'Pending' && !app.endTime && !app.end_time && !app.endDateTime && !app.end_date_time) {
        app.endTime = getFutureIsoTime(45);
        updated = true;
      }
      return app;
    });
    if (updated) {
      setItem(APPLICATIONS_KEY, apps);
    }
    return apps;
  },

  saveApplications(apps) {
    setItem(APPLICATIONS_KEY, apps);
  },

  getRecentActivities() {
    let activities = getItem(ACTIVITIES_KEY);
    if (!activities || !Array.isArray(activities) || activities.length === 0) {
      setItem(ACTIVITIES_KEY, initialActivities);
      return initialActivities;
    }
    return activities;
  },

  addActivity(text, type = 'info') {
    const activities = this.getRecentActivities();
    const newActivity = {
      id: Date.now(),
      text,
      time: 'Just now',
      type
    };
    setItem(ACTIVITIES_KEY, [newActivity, ...activities.slice(0, 9)]);
  },

  acceptRequest(id, amount) {
    const apps = this.getApplications();
    const index = apps.findIndex(a => a.id === id);
    if (index !== -1) {
      if (amount && !apps[index].initialQuote) {
        apps[index].initialQuote = amount;
      }
      if (amount) {
        apps[index].quotedAmount = amount;
      }
      apps[index].status = 'Accepted';
      this.saveApplications(apps);
      this.addActivity(`Accepted request for ${apps[index].deviceModel} (${id})`, 'success');
      return true;
    }
    return false;
  },

  rejectRequest(id) {
    const apps = this.getApplications();
    const index = apps.findIndex(a => a.id === id);
    if (index !== -1) {
      apps[index].status = 'Declined';
      this.saveApplications(apps);
      this.addActivity(`Declined request for ${apps[index].deviceModel} (${id})`, 'error');
      return true;
    }
    return false;
  }
};
